<template>
  <div id="payment-form--alerts">
    <Alert
      class="alert error-messages"
      type="error"
      @close="handleClose"
      ref="error-messages">

      <div v-if="apiError" ref="api-error-messages">
        <p>{{apiError.message}}</p>
        <ul v-for="fieldViolation in apiError.fieldViolations" :key="fieldViolation.field">
          <li
            v-for="(message, index) in fieldViolation.messages"
            :key="`${fieldViolation.field}_${index}`">
            {{message}}
          </li>
        </ul>
      </div>

      <div v-if="formErrors.length > 0" ref="form-error-messages">
        <ul>
          <li v-for="error in formErrors" :key="error.id">
            {{error.msg}}
          </li>
        </ul>
      </div>
    </Alert>
  </div>
</template>

<script>
import Alert from '@/components/Shared/Alert.vue';

export default {
  components: {
    Alert,
  },
  props: {
    apiError: {
      type: Object,
      default: () => {},
    },
    formErrors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>
